import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commaSpace'
})
export class CommaSpacePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return value ? value.split(',').join(', ') : '' ;
  }

}
